site.carousel = {
	init:function() {
		site.owl.init('.box_newsheadlines ul', {
			loop: true,
			nav: true,
			dots:false,
			margin:0,
			autoHeight: true,
			startPosition:2,
			center:true,
			navText:["<i class=\"fa fa-chevron-left\" />","<i class=\"fa fa-chevron-right\" />"],
			items: 1
		});

	}
};

site.inits.push('site.carousel.init()');
